import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 6E7A679E-94FE-4BBD-931F-59B9F25B54EE
 * name umbrella
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/umbrella.svg
 * tags
 * - Weather 
 */
export const UmbrellaIcon = createSvgIcon(<><path d="M12,2A9,9 0 0,1 21,11H13V19A3,3 0 0,1 10,22A3,3 0 0,1 7,19V18H9V19A1,1 0 0,0 10,20A1,1 0 0,0 11,19V11H3A9,9 0 0,1 12,2Z" /></>, 'UmbrellaIcon');
export default UmbrellaIcon